import {
	createStyles,
	makeStyles,
} from '@mui/styles';
import {
	Theme,
} from '@mui/material/styles';

const useStyles = makeStyles((theme: Theme) => {
	return createStyles({
		formPopupPolicyPacketSelection_container: {
			display: 'flex',
			flexDirection: 'column',
		},
		formPopupPolicyPacketSelection_title: {
			color: theme.palette.info.main,
			margin: theme.spacing(2),
		},
		formPopupPolicyPacketSelection_buttonCell: {
			textAlign: 'right',
			border: 'none'
		},
		formPopupPolicyPacketSelection_textCell: {
			textAlign: 'left',
			border: 'none',
			fontWeight: 'bold',
			fontSize: '20px',
		}
	});
});

export default useStyles;
